// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest, makePostRequest } from 'api/fetchCalls'

import type { AuditLogQueryProps, AuditLogResponseProps } from './types'

const AUDIT_LOGS = `${ApiBase}/audit-logs`

function getFormattedQueryParams(query: AuditLogQueryProps): string {
  const params = new URLSearchParams()
  Object.keys(query).forEach((key) => {
    const value = query[key]
    if (value === undefined) return
    if (['created_at__gte', 'created_at__lte'].includes(key)) {
      value instanceof Date &&
        params.append(key, value.toISOString().split('T')[0])
      typeof value === 'string' &&
        params.append(key, new Date(value).toISOString().split('T')[0])
    } else {
      params.append(key, value.toString())
    }
  })
  return params.toString()
}

export async function listAuditLogs(
  query: AuditLogQueryProps = {}
): Promise<AuditLogResponseProps> {
  const formattedQuery = getFormattedQueryParams(query)
  const url =
    formattedQuery !== '' ? `${AUDIT_LOGS}?${formattedQuery}` : AUDIT_LOGS
  const response = await makeGetRequest(url)
  response.results = response.results.map((result) => ({
    ...result,
    created_at: result.created_at
      ? new Date(result.created_at).toLocaleString()
      : null,
  }))
  return response
}

export async function restartAuditLog(uids: string[]): Promise<void> {
  const body = JSON.stringify({ uids })
  const url = `${AUDIT_LOGS}/restart`
  await makePostRequest(url, { body })
}
